import {getService} from "~/lib/services/services-manager";
import {Group} from "~/lib/models/group";

export const removeGroup = async groupUUID => {
  const service = getService("server-app");
  await service.delete(`/admin-client/groups/${groupUUID}`);
}

export const saveGroup = async (group: Group, usersUUIDs: string[], clientUUID: string) => {
  const service = getService("server-app");
  const result = await service.post(`/admin-client/groups`, {
    groupData:group,
    usersUUIDs,
    clientUUID
  });
  return Group.fromPayload(result.data.group);
}
